module.exports = __webpack_public_path__ + "img/VP-Lite_Overview-Rear_1.e2d7a1eb.jpg";